// Copyright 2017 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { IndexedDb, ObjectStoreDefinition } from "libraries/IndexedDb/IndexedDb";

/**
 * Version History:
 * < 7: ???
 * 7: Changed key indexes
 * 8: Added License store
 * 9: updated MeasurementDevice object
 */
@autoinject
export class SoramaPortalCacheDb extends IndexedDb {
    public static MeasurementDeviceStoreName = "MeasurementDevice";
    public static ProjectsStoreName = "Projects";
    public static LicenseStoreName = "License";

    private static databaseName = "sorama-portal-cache";
    private static databaseVersion = 9;
    private static storableObjectNames: ObjectStoreDefinition[] = [
        { name: SoramaPortalCacheDb.MeasurementDeviceStoreName, generateKey: false },
        { name: SoramaPortalCacheDb.ProjectsStoreName, generateKey: false },
        { name: SoramaPortalCacheDb.LicenseStoreName, generateKey: false },
    ];

    constructor() {
        super(
            SoramaPortalCacheDb.databaseName,
            SoramaPortalCacheDb.databaseVersion,
            SoramaPortalCacheDb.storableObjectNames
        );
    }

    protected beforeUpgrade(e: IDBVersionChangeEvent, db: IDBDatabase): void {
        if (e.oldVersion < 7) {
            // Delete all objectStores before this version since we used different key indexes before this version.
            // This can't be upgraded easily and doing an upgrade isn't worth the effort since all data stored until version 7
            // does not need to be persistent anyway.
            while (db.objectStoreNames.length > 0) {
                db.deleteObjectStore(db.objectStoreNames.item(0));
            }
        }
        if (e.oldVersion < 9) {
            // Remove all measurement devices, so that they are reloaded from the server.
            if (db.objectStoreNames.contains(SoramaPortalCacheDb.MeasurementDeviceStoreName)) {
                db.deleteObjectStore(SoramaPortalCacheDb.MeasurementDeviceStoreName);
            }
        }
    }

    protected afterUpgrade(e: IDBVersionChangeEvent, db: IDBDatabase): void {}
}
